/**
 * Arabic Cart Error Translator (v5 - final)
 * - Specific pattern for "The maximum quantity of this item is already in your cart."
 * - Deduplicates: removes the generic toast created by custom.js's listener
 * - No debug display
 */
(function () {
  'use strict';

  function getGenericArabic() {
    return (window.themeHDN && window.themeHDN.extras && window.themeHDN.extras.cart && window.themeHDN.extras.cart.error_message) || '';
  }
  function getToastTitle() {
    return (window.themeHDN && window.themeHDN.extras && window.themeHDN.extras.cart && window.themeHDN.extras.cart.toast_title) || '';
  }
  // Strings come from window.qtratStrings (rendered by snippets/scripts.liquid via the
  // `t` filter). English fallbacks cover layouts that do not render that snippet.
  function qs(key, fallback) {
    var s = window.qtratStrings && window.qtratStrings.cart && window.qtratStrings.cart[key];
    return s || fallback;
  }
  function quantityAddedMsg(qty) {
    return qs('quantity_added', "Only __QTY__ of this item were added to your cart, based on available stock.").replace('__QTY__', qty);
  }
  function maxAlreadyMsg() {
    return qs('max_already_in_cart', "The maximum available quantity of this item is already in your cart.");
  }

  // ====== Track add-to-cart submission ======
  window.__hdtLastSubmit = null;
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], button[name="add"], [data-add-to-cart]') : null;
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;
      var req = parseInt(qtyInput.value, 10);
      var mx = parseInt(qtyInput.getAttribute('max') || qtyInput.max, 10);
      window.__hdtLastSubmit = {
        requested: isNaN(req) ? null : req,
        max: isNaN(mx) ? null : mx,
        time: Date.now()
      };
    } catch (err) {}
  }, true);

  function getCapturedMaxQty() {
    var s = window.__hdtLastSubmit;
    if (s && (Date.now() - s.time) < 15000 && s.max && s.max > 0 && s.max < 99999) return s.max;
    return null;
  }
  function getAnyVisibleMaxQty() {
    var nodes = document.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.offsetParent === null) continue;
      var m = parseInt(n.getAttribute('max') || n.max, 10);
      if (m && m > 0 && m < 99999) return m;
    }
    return null;
  }
  function getBestQuantity() {
    return getCapturedMaxQty() || getAnyVisibleMaxQty();
  }

  // ====== Translation ======
  function translateCartError(message) {
    if (!message || typeof message !== 'string') {
      var fq = getBestQuantity();
      return fq ? quantityAddedMsg(fq) : getGenericArabic();
    }
    var text = String(message).trim();
    if (!/[A-Za-z]/.test(text)) return text;

    // Specific pattern: max already in cart
    if (/maximum\s+quantity\s+of\s+this\s+item\s+is\s+already\s+in\s+your\s+cart/i.test(text)) {
      return maxAlreadyMsg();
    }

    var patterns = [
      /Only\s+(\d+)\s+items?\s+were\s+added\s+to\s+your\s+cart\s+due\s+to\s+availability/i,
      /Only\s+(\d+)\s+items?\s+in\s+.+?\s+were\s+added\s+to\s+your\s+cart/i,
      /You\s+can\s+only\s+add\s+(\d+)\s+of\s+.+?\s+to\s+the\s+cart/i,
      /Only\s+(\d+)\s+of\s+.+?\s+available/i,
      /Only\s+(\d+)\s+available/i
    ];
    for (var p = 0; p < patterns.length; p++) {
      var m = text.match(patterns[p]);
      if (m) return quantityAddedMsg(m[1]);
    }

    var allM = text.match(/All\s+(\d+)\s+.+?\s+are\s+in\s+your\s+cart/i);
    if (allM) return qs('all_in_cart', "All __QTY__ available units are already in your cart.").replace('__QTY__', allM[1]);

    var nm = text.match(/(\d+)/);
    if (nm && /(?:add|cart|item|avail|stock|inventory|qty|quantity)/i.test(text)) {
      return quantityAddedMsg(nm[1]);
    }

    // English text without number - inventory-related fallback
    if (/(?:cart|item|avail|stock|inventory|quantity|error|maximum)/i.test(text)) {
      var fq2 = getBestQuantity();
      if (fq2) return quantityAddedMsg(fq2);
      return maxAlreadyMsg();
    }

    return getGenericArabic() || text;
  }
  window.translateCartErrorAR = translateCartError;

  // ====== PATCH fetch ======
  if (window.fetch && !window.__hdtCartFetchPatched) {
    window.__hdtCartFetchPatched = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function () {
      var args = arguments;
      try {
        var url = '';
        if (typeof args[0] === 'string') url = args[0];
        else if (args[0] && typeof args[0].url === 'string') url = args[0].url;
        if (url.indexOf('/cart/add') === -1 && url.indexOf('/cart/change') === -1 && url.indexOf('/cart/update') === -1) {
          return origFetch.apply(window, args);
        }
        return origFetch.apply(window, args).then(function (response) {
          try {
            var origJson = response.json.bind(response);
            response.json = function () {
              return origJson().then(function (data) {
                try {
                  if (data && typeof data === 'object') {
                    var src = '';
                    if (typeof data.description === 'string' && /[A-Za-z]/.test(data.description)) src = data.description;
                    else if (typeof data.message === 'string' && /[A-Za-z]/.test(data.message)) src = data.message;
                    else if (typeof data.error === 'string' && /[A-Za-z]/.test(data.error)) src = data.error;
                    if (src) {
                      window.__hdtLastRawCartError = src;
                    }
                    if (src || data.status) {
                      var translated = translateCartError(src || null);
                      if (translated) {
                        data.message = translated;
                        if (typeof data.description === 'string') data.description = translated;
                      }
                    }
                  }
                } catch (e) {}
                return data;
              });
            };
            return response;
          } catch (e) { return response; }
        });
      } catch (e) { return origFetch.apply(window, args); }
    };
  }

  // ====== Toast renderer ======
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function getIcon(type) { return ({ error:'!', success:'✓', warning:'!', info:'i' })[type] || 'i'; }
  function ensureContainer() {
    var c = document.querySelector('.toast-container');
    if (!c) { c = document.createElement('div'); c.className = 'toast-container'; document.body.appendChild(c); }
    return c;
  }
  function showToast(message, type, title) {
    var container = ensureContainer();
    var toast = document.createElement('div');
    toast.className = 'toast ' + type + ' hdt-ar-toast';
    toast.innerHTML =
      '<div class="toast-header">' +
        '<div class="toast-icon ' + type + '">' + getIcon(type) + '</div>' +
        '<div class="toast-title">' + escapeHtml(title || '') + '</div>' +
        '<button type="button" class="toast-close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="toast-body">' + escapeHtml(message) + '</div>';
    container.appendChild(toast);
    setTimeout(function () { toast.classList.add('show'); }, 10);
    var btn = toast.querySelector('.toast-close');
    if (btn) btn.addEventListener('click', function () { hideToast(toast); });
    setTimeout(function () { hideToast(toast); }, 5000);
    return toast;
  }
  function hideToast(toast) {
    toast.classList.add('hide');
    setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
  }

  // Remove the generic toast that custom.js's listener creates (it fires BEFORE us
  // because it was registered first - stopImmediatePropagation doesn't help when
  // events are dispatched directly on window).
  function removeGenericToast() {
    var genericText = getGenericArabic();
    if (!genericText) return;
    var toasts = document.querySelectorAll('.toast-container .toast.error');
    for (var i = 0; i < toasts.length; i++) {
      var t = toasts[i];
      if (t.classList.contains('hdt-ar-toast')) continue; // our own - leave alone
      var body = t.querySelector('.toast-body');
      if (body && body.textContent.trim() === genericText.trim()) {
        if (t.parentNode) t.parentNode.removeChild(t);
      }
    }
  }

  function translateInlineErrors() {
    var nodes = document.querySelectorAll('.hdt-error-message, .hdt-error-message-text');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = el.textContent;
      if (!t || !/[A-Za-z]/.test(t)) continue;
      var translated = translateCartError(t);
      if (translated && translated !== t) el.textContent = translated;
    }
  }

  // ====== cart:error listener ======
  // Fires AFTER custom.js's listener (because custom.js loads first).
  // We remove the generic toast that custom.js just created, then add our accurate one.
  window.addEventListener('cart:error', function (event) {
    event.stopImmediatePropagation();
    var detail = event.detail || {};
    var data = detail.data || {};
    var rawMessage =
      (typeof data.message === 'string' ? data.message : '') ||
      (typeof data.description === 'string' ? data.description : '') ||
      '';
    var arabic = translateCartError(rawMessage);

    // Kill the duplicate generic toast custom.js just created
    removeGenericToast();
    // Also schedule another removal in case custom.js's toast renders late
    setTimeout(removeGenericToast, 50);
    setTimeout(removeGenericToast, 200);

    showToast(arabic, 'error', getToastTitle());

    var attempts = 0;
    (function tick() {
      translateInlineErrors();
      if (++attempts < 8) setTimeout(tick, 120);
    })();
  }, true);

  // ====== MutationObserver: inline messages + dedupe generic toasts ======
  function startObserver() {
    translateInlineErrors();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var mut = muts[i];
        if (mut.type === 'characterData') {
          var p = mut.target.parentNode;
          if (!p) continue;
          var target = null;
          if (p.classList && (p.classList.contains('hdt-error-message') || p.classList.contains('hdt-error-message-text'))) target = p;
          else if (p.closest) target = p.closest('.hdt-error-message, .hdt-error-message-text');
          if (target) {
            var t = target.textContent;
            if (t && /[A-Za-z]/.test(t)) {
              window.__hdtLastRawCartError = t;
              var translated = translateCartError(t);
              if (translated && translated !== t) target.textContent = translated;
            }
          }
        } else if (mut.type === 'childList') {
          for (var j = 0; j < mut.addedNodes.length; j++) {
            var node = mut.addedNodes[j];
            if (!node || node.nodeType !== 1) continue;
            // Inline error message translation
            var els = [];
            if (node.matches && node.matches('.hdt-error-message, .hdt-error-message-text')) els.push(node);
            if (node.querySelectorAll) {
              var inner = node.querySelectorAll('.hdt-error-message, .hdt-error-message-text');
              for (var k = 0; k < inner.length; k++) els.push(inner[k]);
            }
            for (var mm = 0; mm < els.length; mm++) {
              var t2 = els[mm].textContent;
              if (t2 && /[A-Za-z]/.test(t2)) {
                window.__hdtLastRawCartError = t2;
                var tr2 = translateCartError(t2);
                if (tr2 && tr2 !== t2) els[mm].textContent = tr2;
              }
            }
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();
})();
